export interface WidgetState {
  widgetV3InstanceId: number;
  autoPublish: boolean;
  font: string;
  primaryColor: string;
  starRatingColor: string;
  fontChanged: boolean;
  primaryColorChanged: boolean;
  starRatingColorChanged: boolean;
  doneInstallation: boolean;
};

export const initialWidgetState: WidgetState = {
  widgetV3InstanceId: null,
  autoPublish: true,
  font: '',
  primaryColor: '',
  starRatingColor: '',
  fontChanged: false,
  primaryColorChanged: false,
  starRatingColorChanged: false,
  doneInstallation: false
};
